import React from 'react'
import BreadCrumbs from '../../components/Layout/breadcrumbs/breadcrumbs'

import SEOHelmet from '../../components/Layout/SEOHelmet'
import Footer from "../../components/Layout/footer"
import TocList from '../../components/Products/TocList-FAQs'

const seodata = {
  title: 'Frequently Asked Questions',
  description: 'Frequently Asked Questions for INSTAR IP Cameras.',
  image: '/images/Search/FAQ_SearchThumb.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />

        <BreadCrumbs
          pills={
            [
              {
                pill: "Home",
                link: "/fr/"
              },
              {
                pill: "Products",
                link: "/fr/Products/"
              },
              {
                pill: "FAQs",
                link: "/fr/FAQs/"
              }
            ]
          } />

        <h1>Frequently Asked Questions</h1>
        <TocList />
        <br />
        <br />
        <Footer
          previousTitle="Indoor Cameras"
          previousLink="/fr/Indoor_Cameras/"
          nextTitle="Outdoor Cameras"
          nextLink="/fr/Outdoor_Cameras/" />
      </React.Fragment>
    )